import script from "./PatientAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAlerts.vue?vue&type=script&setup=true&lang=js"

import "./PatientAlerts.vue?vue&type=style&index=0&id=2c22910a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c22910a"]])

export default __exports__